export default __webpack_public_path__ + "static/media/016-pizza cutter.691522e5.svg";